import { useNavigate } from 'react-router-dom';
import { REDUX_APP_SET_WEATHER_WARNING_BANNER } from 'redux-state/app/reducer.js';
import { useAppDispatch } from 'redux-state/configure-store.js';

interface IAddAsLink {
  link: boolean;
  url: string;
  children: JSX.Element;
  classes?: string;
}
/** Links within warning bar content */
export const WarningBarAddAsLink = ({ link, url, classes, children }: IAddAsLink) => {
  const appDispatch = useAppDispatch();
  const navigate = useNavigate();
  if (link) {
    return (
      <div
        style={{ textDecoration: 'none', color: 'inherit' }}
        className={classes ?? ''}
        onClick={(e) => {
          // when warning bar item selected, close warning banner and go to that page
          appDispatch(REDUX_APP_SET_WEATHER_WARNING_BANNER({ isOpen: false }));

          navigate(url);
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        {children}
      </div>
    );
  }
  return children;
};
